import React from 'react';

import { PermissionList } from '../../../helpers/Permissions';

import CasinoGame from 'casino/Api/Models/CasinoGame';
import { replaceUrlParams } from 'crm/casino/pages/Helpers/UrlHelper';
import DeleteButton from 'crm/elements/DeleteButton';

interface Props {
    games: CasinoGame[];
    deleteUrl: string;
    deleteCallback: (game: CasinoGame) => void;
    permissions: PermissionList;
}

const EditableGameList = ({ games, deleteUrl, deleteCallback, permissions }: Props) => {
    if (games.length === 0) {
        return (
            <div className="d-flex flex-wrap">
                <span className="text-danger">No games</span>
            </div>
        );
    }

    return (
        <div className="d-flex flex-wrap">
            {games.map((game) => {
                return (
                    <div className="card" style={{ width: '20%', padding: '6px' }} key={game.id}>
                        <img className="card-img-top" src={game.image} alt={game.name} />
                        <div className="card-body">
                            <h5>{game.creator_name}</h5>
                            <h4 className="card-title" style={{ marginBottom: '25px' }}>
                                {game.name}
                            </h4>
                            <div className="d-flex justify-content-between">
                                <DeleteButton
                                    url={replaceUrlParams(deleteUrl, { gameId: game.id })}
                                    action={() => deleteCallback(game)}
                                    permissions={permissions}
                                    key="delete"
                                />
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default EditableGameList;
